import { useEffect } from "react";
import { useChannels, useConversations, useNotifications } from "../api/queries";
import { useTaskSearch } from "../api/tasks";
import { callNative, inNativeApp } from "./native";
import { VIEW_FILTERS } from "./tasks";

type BadgeNavigator = Navigator & { setAppBadge?: (n?: number) => Promise<void>; clearAppBadge?: () => Promise<void> };

/** 로그아웃하면 아이콘의 숫자를 지운다 */
export function clearAppBadge() {
  if (inNativeApp()) return void callNative("badge", { count: 0 }).catch(() => {});
  const nav = navigator as BadgeNavigator;
  nav.clearAppBadge?.().catch(() => {});
}

/**
 * 앱 아이콘 배지 (설치한 앱에서만 보인다. iPhone은 알림을 허용해야 한다. JustOne 앱은 앱에게 숫자를 넘긴다).
 * 서버의 badgeCount와 같은 규칙: 안 읽은 메시지 + 안 읽은 알림(본문 멘션 제외) + 오늘까지인 할일.
 * 앱이 닫혀 있는 동안에는 푸시에 실려 온 숫자로 서비스 워커가 바꾼다.
 */
export function useAppBadge() {
  const { data: channels } = useChannels();
  const { data: conversations } = useConversations();
  const { data: notes } = useNotifications();
  const { data: today } = useTaskSearch(VIEW_FILTERS.today);
  // 다 받기 전에는 바꾸지 않는다 (앱을 열 때 숫자가 잠깐 지워졌다 다시 생기지 않게)
  const count =
    channels && conversations && notes && today
      ? channels.reduce((n, c) => n + c.unread, 0) +
        conversations.reduce((n, c) => n + c.unread, 0) +
        Math.max(0, notes.unread - notes.notifications.filter((x) => !x.read && x.type === "mention" && x.rootId === null).length) +
        today.length
      : null;

  useEffect(() => {
    if (count !== null && inNativeApp()) return void callNative("badge", { count }).catch(() => {});
    const nav = navigator as BadgeNavigator;
    if (count === null || !nav.setAppBadge) return;
    (count > 0 ? nav.setAppBadge(count) : (nav.clearAppBadge?.() ?? Promise.resolve())).catch(() => {});
  }, [count]);
}
